import React, { Fragment, FunctionComponent, useCallback, useEffect } from "react";
import styles from "./MenuOverlay.module.scss";

import { CLOSE_ALL_OVERLAYS } from "layout/redux/overlay.actions";
import { Helmet } from "react-helmet-async";
import Anchor from "components/Anchor/Anchor";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useWindowDimensions from "hooks/useWindowDimensions";
import combineClasses from "helpers/combine-classes";
import { useDispatch } from "react-redux";
import SocialLinks from "../SocialLinks/SocialLinks";
import LanguageSelector from "layout/Header/blocks/Header1/components/LanguageSelector/LanguageSelector";

const MenuOverlay: FunctionComponent<any> = (props) => {
    const { width } = useWindowDimensions();
    const dispatch = useDispatch();

    const logoTypeClass = props.header?.logoType ? styles[`logo_type_${props.header.logoType}`] : undefined;
    const logoImageType = props.header?.logoType === "Vertical" ? "containX" : "containY";
    const imageAspectRatio = getImageAspectRatio(undefined, props.header?.logo?.umbracoWidth, props.header?.logo?.umbracoHeight);

    const onEscKeyInput = useCallback((event) => {
        if (event.keyCode === 27) {
            dispatch({
                type: CLOSE_ALL_OVERLAYS,
            });
        }
    }, []);

    const onCloseButtonClick = useCallback((event) => {
        dispatch({
            type: CLOSE_ALL_OVERLAYS,
        });
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", onEscKeyInput, false);

        return () => {
            document.removeEventListener("keydown", onEscKeyInput, false);
        };
    }, []);

    return (
        <Fragment>
            {/* Lock the scrollbar for the rest of the page on mobile, while drawer is open */}
            {/* TODO: Remember the scroll position and restore it when toggling locked state */}
            {width <= 570 ? <Helmet bodyAttributes={{ class: "is-locked" }} /> : null}

            <nav className={styles.wrapper}>
                <div className={combineClasses(styles.inner, logoTypeClass)}>
                    <div className={styles.header}>
                        {props.header?.logo ? (
                            <Anchor
                                className={styles.image_link}
                                to={props.page?._homeNodeUrl}
                            >
                                <ImageViewer
                                    className={styles.image}
                                    src={props.header.logo.umbracoFile.src}
                                    extensionType="png"
                                    type={logoImageType}
                                    aspectRatioX={imageAspectRatio.aspectRatioX}
                                    aspectRatioY={imageAspectRatio.aspectRatioY}
                                />
                            </Anchor>
                        ) : null}

                        <button
                            className={styles.menu_close_button}
                            onClick={(event) => onCloseButtonClick(event)}
                        >
                            <span></span>
                            <span></span>
                        </button>
                    </div>

                    {props.menu ? (
                        <div className={styles.links}>
                            {props.menu?.map((level1Item: any, index: number) => {
                                return (
                                    <Anchor
                                        key={index}
                                        className={styles.link}
                                        to={level1Item.content.link}
                                    >
                                        <span className={styles.link_label}>{level1Item.content.label}</span>
                                    </Anchor>
                                );
                            })}
                        </div>
                    ) : null}

                    <div className={styles.buttons}>
                        <div className={styles.buttons_social}>
                            {/* Social Links */}
                            <SocialLinks {...props} />

                            {/* Language Selector */}
                            {props?._cultures && Object.keys(props._cultures).length > 1 ? (
                                <LanguageSelector
                                    culture={props._culture}
                                    cultures={props._cultures}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            </nav>
        </Fragment>
    );
};

export default MenuOverlay;
